export const inspection = [
  { path: 'created', title: 'Creación', icon: 'mdi-calendar-blank-outline' },
]
